import { post } from "../client";
import { LOGIN, REGISTER } from "../routes";

export default {
  login: async (data) => await post(LOGIN, data, false),

  register: async (data) => await post(REGISTER, data, false),
};
